import Component from '../app/component';

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {
      active: false
    };
  }

  init() {
    document.addEventListener('mobilemenu.toggle', () => this.toggle());
  }

  toggle() {
    this.data.active = !this.data.active;
  }

  watchActive(value) {
    if (value) {
      this.el.classList.add('mobilemenu--active');
      document.body.classList.add('layout-unscrollable');
      document.dispatchEvent(new CustomEvent('mobilemenu.is.active'));
    } else {
      this.el.classList.remove('mobilemenu--active');
      document.body.classList.remove('layout-unscrollable');
      document.dispatchEvent(new CustomEvent('mobilemenu.isnot.active'));
    }
  }
}
